var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-xl mb-8 flex" },
    [_vm._t("default"), _c("Spacer"), _vm._t("action")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }